<template>
  <div class="refund">
    <div class="order-detail">
      <div class="base-info">
        <span>{{ agreementContent.billNo }} </span>
        <span>{{ agreementContent.createAt }}</span>
        <span class="underway" v-if="agreementContent.status < 10">进行中</span>
        <span class="underway discard" v-if="agreementContent.status == 10">
          已作废
        </span>
        <span class="underway finish" v-if="agreementContent.status == 11"
          >已完结</span
        >
      </div>
      <div class="order-name">{{ agreementContent.partyAName }}</div>
      <div class="order-price">
        <div>
          <span>预估费用：</span>
          <span class="price">{{ agreementContent.estimateTotalCost }}</span>
        </div>
        <div>
          <span>核价费用：</span>
          <span class="price">{{ agreementContent.price || "暂无" }}</span>
        </div>
      </div>
      <div class="tips">当前状态</div>
      <div class="steps">
        <span :class="agreementContent.status == 0 ? 'active' : ''"
          >协议签订</span
        >
        <div class="line">———</div>
        <span :class="agreementContent.status == 1 ? 'active' : ''">审核</span>
        <div class="line">———</div>
        <span
          :class="
            agreementContent.status > 1 && agreementContent.status < 7
              ? 'active'
              : ''
          "
        >
          设计
        </span>
        <div class="line">———</div>
        <span :class="agreementContent.status > 6 ? 'active' : ''">核价</span>
      </div>
      <van-divider dashed></van-divider>
      <div>
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item
            v-for="(item, index) in reimbursementList"
            :key="index"
            :title="
              '第' +
                (index + 1) +
                '次报销:' +
                (item.status != 4
                  ? item.amount
                    ? item.amount / 100
                    : '0'
                  : '0') +
                '元'
            "
            :name="index"
          >
            <div class="attachmentStyle">
              <div
                v-for="(attachment, indexAttachment) in item.attachments"
                :key="indexAttachment"
              >
                <van-image
                  width="88"
                  height="88"
                  fit="contain"
                  :src="$imgPath + attachment.path"
                  @click="previewImg"
                >
                  <template v-slot:error>未上传</template>
                </van-image>
              </div>
            </div>
            <div>
              <span style="font-size: 14px">{{
                item.status == 1
                  ? "审核中"
                  : item.status == 2
                  ? "审核通过"
                  : item.status == 4
                  ? "审核失败:" + item.remark
                  : ""
              }}</span>
            </div>
          </van-collapse-item>
        </van-collapse>
        <!-- <div>
          <span> 第{{ index + 1 }}次报销：{{ item.amount / 100 }}元 </span>
        </div> -->
        <!-- <div class="attachmentStyle">
          <div
            v-for="(attachment, indexAttachment) in item.attachments"
            :key="indexAttachment"
          >
            
          </div>
        </div> -->
      </div>
    </div>
    <div
      class="refund-fail"
      v-if="
        !agreementContent.reimbursementSuccessful &&
          (agreementContent.reimbursementSuccessful != null ||
            agreementContent.reimbursementSuccessful != undefined) &&
          agreementContent.status == 8
      "
    >
      <div class="title">报销失败</div>
      <div class="content">
        {{ agreementContent.reimbursementRemark }}
      </div>
    </div>
    <!-- <div class="upload-img" v-if="reimbursementSuccessful">
      <div class="title">已上传凭证</div>
      <van-image
        width="88"
        height="88"
        fit="contain"
        :src="$imgPath + item.path"
        @click="previewImg"
        v-for="(item, index) in passImgArr"
        :key="index"
      >
      </van-image>
    </div> -->
    <div class="upload-img" v-if="!reimbursementSuccessful">
      <div class="title">上传广告安装图片</div>
      <van-uploader
        v-model="installImgList"
        multiple
        name="installImg"
        :max-count="6"
        :after-read="afterRead"
        :before-delete="beforeDelete"
        :before-read="beforeRead"
      />
    </div>
    <div class="upload-img" v-if="!reimbursementSuccessful">
      <div class="title">上传报销费用凭证图片</div>
      <van-uploader
        v-model="costImgList"
        multiple
        name="costImg"
        :max-count="6"
        :after-read="afterRead"
        :before-delete="beforeDelete"
        :before-read="beforeRead"
      />
    </div>
    <div class="upload-img" v-if="agreementContent.status < 10">
      <div class="title">上传进货凭证图片</div>
      <van-uploader
        v-model="stockImgList"
        multiple
        name="stockImg"
        :max-count="6"
        :after-read="afterRead"
        :before-delete="beforeDelete"
        :before-read="beforeRead"
      />
    </div>
    <div>
      <van-field v-model.trim="reimbursementForm.remark1" label="备注" placeholder="请输入备注" />
    </div>
    <div class="btn" v-if="agreementContent.status < 10 && status">
      <van-button to="refund" type="warning" @click="handleReimbursement">
        申请报销
      </van-button>
    </div>
    <div class="tips" v-if="agreementContent.status < 10 && status">
      提交后，请将相关资料快递至公司
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import * as imageConversion from "image-conversion";
import { Dialog } from "vant";
import { ImagePreview } from "vant";
import {
  adDetails,
  uploadImg,
  reimbursement,
  reimbursementDetail,
  reimbursements
} from "@/api/advertising";
export default {
  data() {
    return {
      installImgList: [],
      installImgArr: [],
      costImgList: [],
      costImgArr: [],
      stockImgList: [],
      stockImgArr: [],
      agreementContent: {},
      reimbursementForm: {
        attachments: [],
        id: this.$route.query.id,
        remark1: ""
      },
      passImgArr: [],
      reimbursementList: [],
      status: true,
      reimbursementSuccessful: false,
      attachments: [],
      activeName: "1",
      activeText: "第"
    };
  },
  created() {
    this.getDetail();
    reimbursementDetail(this.$route.query.id).then(res => {
      this.attachments = res.result;
      this.getReimbursements();
    });
  },
  methods: {
    // 广告详情
    getDetail() {
      adDetails(this.$route.query.id).then(res => {
        // console.log("广告详情: ", res.result);
        res = res.result;
        this.agreementContent = res.apply;
        this.getReimbursementDetail();
      });
    },
    // 报销详情
    getReimbursementDetail() {
      let vm = this;
      reimbursementDetail(this.$route.query.id).then(res => {
        res.result.forEach(val => {
          if (val.reimbursementStatus == 2) {
            vm.passImgArr.push({
              mediaType: val.mediaType,
              name: val.name,
              path: val.path,
              type: val.type
            });
          }
          if (
            val.reimbursementStatus == 1 &&
            val.reimbursementNum == this.agreementContent.reimbursementNum
          ) {
            this.status = false;
          }
        });
        if (!this.agreementContent.reimbursementSuccessful) {
          res.result.forEach(val => {
            switch (val.type) {
              case 1:
                if (
                  (val.reimbursementStatus == 4 ||
                    val.reimbursementStatus == 1) &&
                  val.reimbursementNum == this.agreementContent.reimbursementNum
                ) {
                  vm.stockImgArr.push({
                    mediaType: val.mediaType,
                    name: val.name,
                    path: val.path,
                    type: val.type
                  });
                  vm.stockImgList.push({
                    url: vm.$imgPath + val.path
                  });
                }
                break;
              case 2:
                if (
                  (val.reimbursementStatus == 4 ||
                    val.reimbursementStatus == 1) &&
                  val.reimbursementNum == this.agreementContent.reimbursementNum
                ) {
                  vm.installImgArr.push({
                    mediaType: val.mediaType,
                    name: val.name,
                    path: val.path,
                    type: val.type
                  });
                  vm.installImgList.push({
                    url: vm.$imgPath + val.path
                  });
                }
                break;
              case 4:
                if (
                  (val.reimbursementStatus == 4 ||
                    val.reimbursementStatus == 1) &&
                  val.reimbursementNum == this.agreementContent.reimbursementNum
                ) {
                  vm.costImgArr.push({
                    mediaType: val.mediaType,
                    name: val.name,
                    path: val.path,
                    type: val.type
                  });
                  vm.costImgList.push({
                    url: vm.$imgPath + val.path
                  });
                }
                break;
            }
          });
        }
      });
    },
    // 费用报销列表
    getReimbursements() {
      reimbursements(this.$route.query.id).then(res => {
        console.log("费用报销列表 :>> ", res);
        res.result.forEach(val => {
          val.attachments = this.currentNumAttachments(val.num);
          this.reimbursementList.push(val);
          this.reimbursementSuccessful = true;
        });
        this.reimbursementList.reverse();
        console.log(this.reimbursementList, "reimbursementList=>");
      });
    },
    currentNumAttachments(num) {
      return this.attachments.filter(item => item.reimbursementNum === num);
    },
    // 上传图片前
    beforeRead(file) {
      if (file.type != "image/png" && file.type != "image/jpeg") {
        this.$toast("请上传png、jpeg图片格式");
        return false;
      }
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file, name) {
      let vm = this;
      let imgObj = {
        mediaType: "",
        name: "",
        path: "",
        type: 1
      };
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      uploadImg(data)
        .then(res => {
          // console.log("图片上传结果 :>> ", res);
          imgObj.mediaType = res.type;
          imgObj.name = res.title;
          imgObj.path = res.url;
          switch (name.name) {
            case "installImg":
              imgObj.type = 2;
              vm.installImgArr.push(imgObj);
              break;
            case "costImg":
              imgObj.type = 4;
              vm.costImgArr.push(imgObj);
              break;
            case "stockImg":
              imgObj.type = 1;
              vm.stockImgArr.push(imgObj);
              break;
          }
          file.status = "done";
          file.message = "上传成功";
        })
        .catch(err => {
          console.log(err);
          switch (name.name) {
            case "installImg":
              this.installImgList.splice(this.installImgList.length - 1, 1);
              break;
            case "costImg":
              this.costImgList.splice(this.costImgList.length - 1, 1);
              break;
            case "stockImg":
              this.stockImgList.splice(this.stockImgList.length - 1, 1);
              break;
          }
          Toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      switch (detail.name) {
        case "installImg":
          this.installImgList.splice(detail.index, 1);
          this.installImgArr.splice(detail.index, 1);
          break;
        case "costImg":
          this.costImgList.splice(detail.index, 1);
          this.costImgArr.splice(detail.index, 1);
          break;
        case "stockImg":
          this.stockImgList.splice(detail.index, 1);
          this.stockImgArr.splice(detail.index, 1);
          break;
      }
    },
    // 申请报销
    handleReimbursement() {
      this.reimbursementForm.attachments = this.installImgArr.concat(
        this.costImgArr,
        this.stockImgArr
      );
      reimbursement(this.reimbursementForm).then(res => {
        if (res.code == 0) {
          Dialog.alert({
            title: "提示",
            message: "您的报销申请已提交！",
            confirmButtonText: "关闭"
          }).then(() => {
            this.$router.push({
              path: "/agency/history"
            });
          });
        } else {
          this.submitStatus = false;
          Dialog.alert({
            title: "提示",
            message: "提交失败,请检查",
            confirmButtonText: "关闭"
          });
        }
      });
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    }
  }
};
</script>
<style lang="scss" scoped>
.order-detail {
  padding: 10px;
  border-bottom: 10px solid #f1f1f1;
  border-radius: 5px;
  text-align: left;
  font-size: 16px;

  .base-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .underway {
      color: #03940a;
    }

    .discard {
      color: #ccc;
    }

    .finish {
      color: red;
    }
  }

  .order-name {
    margin-bottom: 10px;
    font-size: 18px;
  }

  .order-price {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .price {
      color: red;
    }
  }

  .tips {
    font-size: 14px;
    color: #5d5b5b;
    margin-bottom: 5px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      padding: 1px 3px;
    }

    .active {
      background-color: #00a0e9;
      color: #fff;
    }
  }

  .van-divider {
    border-color: #000;
  }
}

.refund-fail {
  padding: 10px;
  border-bottom: 10px solid #f1f1f1;
  text-align: left;

  .title {
    color: #c83838;
  }

  .content {
    color: #686868;
  }
}

.upload-img {
  padding: 10px;
  text-align: left;

  .title {
    margin-bottom: 20px;
  }
}

.btn {
  margin-top: 20px;
  margin-bottom: 5px;
  text-align: center;
}

.tips {
  font-size: 12px;
  text-align: center;
  color: #979797;
}
.attachmentStyle {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
